import React from 'react'
import Navbar from '../components/Navbar/Navbar'
import Pricing from '../components/Pricing/Pricing'
import Footer from '../components/Footer/Footer'
import Pricingsecond from '../components/Pricing/Pricingsecond'
import PricingThird from '../components/Pricing/PricingThird'

const Pricingpage = () => {
    return (
        <div>

        <Navbar/>
        <Pricing/>
        <Pricingsecond/>
        <PricingThird/>
        <Footer/>


        </div>
    )
}

export default Pricingpage